import { component } from 'picoapp'
import { addVariant } from 'base/scripts/utils/cart.js'
import { qs, qsa, has, on } from 'martha'
import choozy from 'choozy'

export default component((node, ctx) => {
  let { subDetailToggle, subDetail } = choozy(node)

  const json = JSON.parse(qs('.js-product-json', node).innerHTML)
  const form = qs('form', node)
  const addBtn = qsa('.js-add-to-cart', node)
  const navBtn = qs('.product-nav-btn', node)
  let qty = qs('.js-single-quantity-nav')
  let selectedQuantity = 1
  let nav = qs('.product-add-nav')
  const addText = addBtn.innerHTML || 'Add To Cart'
  let selling_plan

  const { selectedOrFirstAvailableVariant, product } = json
  let currentVariant = product.variants.filter(
    (v) => v.id === selectedOrFirstAvailableVariant
  )[0]

  if(node.dataset?.type != 'bundle'){
    ctx.on('cart:toggle', () => {
      addBtn.forEach((btn) => {
        btn.innerHTML = addText
      })
    })
  }
  

  addBtn.forEach((btn) => {
    on(btn, 'click', (e) => {
      e.preventDefault()

      if (has(qs('.product-variant-wrap', node), 'is-subscription')) {
        selling_plan = parseInt(
          (selling_plan = parseInt(qs('.js-toggleFrequency', node).dataset.id))
        )
      } else {
        selling_plan = null
      }

      // addBtn.innerHTML = 'adding...'

      let selectedVariant = qs('select[name="id"]', node).value

      currentVariant = selectedVariant
        ? product.variants.filter(
            (v) => v.id === parseInt(qs('select[name="id"]', node).value)
          )[0]
        : currentVariant

      addVariant(currentVariant, 1, selling_plan)
      console.log(json)
    })
  })

  return () => {}
})
